export default "__VITE_ASSET__COl3s2Ea__"